export enum DateRangeProperty {
    From = 'from',
    To = 'to',
}
